import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class Copyright extends BaseOption {
  static userInterfaceComponent = {
    label: "Copyright",
    component: inspectorTools.RICH_TEXT_INPUT,
  };

  static defaultValue = "Add your copyright text here";
}
